export default {
  bgImg: "septiembre.png",
  iconHeaders: "chile.png",
  logoLogin: "ticket-septiembre.png",
  logoSidebar: "ticket-septiembre.png",
  logoMini: "M_Maximiza.png",
  menuColor: "primary",
  btnColor: "primary",
  chipColor: "primary",
  badgeColor: "primary",
  infoTextColor: "info",
  scheduleTextColor: "black",
  colorBar: "rgba(255, 255, 255, 0.9)",
  revisionColor: "error",
  dark: false,
}; //Normal

// export default {
//   bgImg: "bg-halloween-2.jpg",
//   iconHeaders: "pumpkin.png",
//   logoLogin: "logo-halloween.png",
//   logoSidebar: "logo-halloween.png",
//   logoMini: "M_Maximiza.png",
//   colorBar: "rgba(91, 63, 128, 0.5)",
//   menuColor: "white",
//   btnColor: "#ff7301",
//   chipColor: "#ff7301",
//   badgeColor: "#ff7301",
//   infoTextColor: "white",
//   scheduleTextColor: "white",
//   dark: true,
// }; //Halloween

// export default {
//   bgImg: "bg-navidad-4.png",
//   iconHeaders: "navidad.png",
//   logoLogin: "mxz_ticket_navidad.png",
//   logoSidebar: "mxz_ticket_navidad.png",
//   logoMini: "M_Maximiza_blanco.png",
//   menuColor: "white",
//   btnColor: "amber",
//   chipColor: "amber",
//   badgeColor: "amber",
//   infoTextColor: "white",
//   scheduleTextColor: "white",
//   colorBar: "rgba(197, 46, 46, 0.8)",
//   revisionColor: "white",
//   dark: true,
// }; //Navidad
